import { render, staticRenderFns } from "./CriarLote2.vue?vue&type=template&id=827b7e64&"
import script from "./CriarLote2.vue?vue&type=script&lang=js&"
export * from "./CriarLote2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports